import { ENTRY_DATA_SECTION_KEYS as SECTION_KEYS } from "@frontend/common";

export const DEAL_SWAP_ROLES_BUTTON_TARGET_TABLE_KEYS = [
  "Licensor",
  "Licensee",
  "Acquired Company",
  "Acquiring Company",
];

export const DEAL_SWAP_ROLES_ARTICLE_SECTION = [
  SECTION_KEYS.deals,
  SECTION_KEYS.dealFiling,
] as const;
